import { Avatar, Box } from "@material-ui/core";
import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useStyles } from "../../../quoteDetailPage/quoteDetail.styles";

export const AssessmentComment = ({ quote }: { quote: Quote }) => {
  const { isMoreThanSm } = useBreakpoint();
  const classes = useStyles();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      paddingX={isMoreThanSm ? 0 : "50px"}
      justifyContent={"center"}
    >
      <Box textAlign={"center"}>
        <Box fontSize={isMoreThanSm ? "28px" : "20px"} fontWeight={500} color={"#160337"}>
          Assessment <span style={{ color: "#f7815c" }}>Comments</span>
        </Box>
        {quote.assessor?.photoUrl && (
          <Box display="flex" justifyContent="center" my={4}>
            <Avatar alt="Assessor" src={quote.assessor.photoUrl} className={classes.avatar} />
          </Box>
        )}
        <Box fontSize={isMoreThanSm ? "16px" : "14px"} mt={"14px"} fontWeight={400} color={"#4b5462"}>
          Following the technical survey, your assessor conducted the notes below:
        </Box>
      </Box>
      <Box
        maxWidth={"769px"}
        width={"100%"}
        fontSize={"14px"}
        marginTop={"45px"}
        fontWeight={400}
        color={"rgba(17, 21, 33, 0.65)"}
      >
        {quote.customerText?.split("\n").map((item, idx) => (
          <Box key={idx} marginBottom={"14px"}>
            {item}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
